var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoDesarrollate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 103.012,
    height: 103.013,
    viewBox: "0 0 103.012 103.013",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_33",
    "data-name": "Grupo 33",
    transform: "translate(-88.528 -381.283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_30",
    "data-name": "Grupo 30",
    transform: "translate(90.245 383)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_5",
    "data-name": "Rect\\xE1ngulo 5",
    width: 85.844,
    height: 51.506,
    transform: "translate(6.868 3.434)",
    fill: "#a4c2f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6",
    "data-name": "Rect\\xE1ngulo 6",
    width: 80.693,
    height: 51.506,
    transform: "translate(6.868 3.434)",
    fill: "#e3e7f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_78",
    "data-name": "Elipse 78",
    cx: 6.867,
    cy: 6.867,
    r: 6.867,
    transform: "translate(42.922 65.241)",
    fill: "#d4e1f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_298",
    "data-name": "Trazado 298",
    d: "M141.183,503.285v-9.074a10.314,10.314,0,0,1,20.6,0v9.074Z",
    transform: "translate(-101.695 -405.424)",
    fill: "#e3e7f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_79",
    "data-name": "Elipse 79",
    cx: 6.867,
    cy: 6.867,
    r: 6.867,
    transform: "translate(75.542 65.241)",
    fill: "#d4e1f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_299",
    "data-name": "Trazado 299",
    d: "M182.869,503.285v-9.074a10.313,10.313,0,0,1,20.6,0v9.074Z",
    transform: "translate(-110.76 -405.424)",
    fill: "#e3e7f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_80",
    "data-name": "Elipse 80",
    cx: 6.867,
    cy: 6.867,
    r: 6.867,
    transform: "translate(10.301 65.241)",
    fill: "#d4e1f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_300",
    "data-name": "Trazado 300",
    d: "M99.5,503.284V494.21a10.314,10.314,0,0,1,20.6,0v9.074Z",
    transform: "translate(-92.63 -405.423)",
    fill: "#e3e7f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_27",
    "data-name": "Grupo 27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_301",
    "data-name": "Trazado 301",
    d: "M94.156,383.477h92.711a3.434,3.434,0,0,1,3.434,3.434h0a3.433,3.433,0,0,1-3.434,3.434H94.156a3.433,3.433,0,0,1-3.434-3.434h0A3.434,3.434,0,0,1,94.156,383.477Z",
    transform: "translate(-90.722 -383.477)",
    fill: "#a4c2f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_302",
    "data-name": "Trazado 302",
    d: "M94.156,449.3h92.711a3.434,3.434,0,0,1,3.434,3.434h0a3.433,3.433,0,0,1-3.434,3.434H94.156a3.433,3.433,0,0,1-3.434-3.434h0A3.434,3.434,0,0,1,94.156,449.3Z",
    transform: "translate(-90.722 -397.79)",
    fill: "#a4c2f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_28",
    "data-name": "Grupo 28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_303",
    "data-name": "Trazado 303",
    d: "M94.067,383.477H181.8a3.345,3.345,0,0,1,3.345,3.345V387a3.344,3.344,0,0,1-3.345,3.345H94.067A3.344,3.344,0,0,1,90.722,387v-.178A3.345,3.345,0,0,1,94.067,383.477Z",
    transform: "translate(-90.722 -383.477)",
    fill: "#d4e1f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_304",
    "data-name": "Trazado 304",
    d: "M94.067,449.3H181.8a3.345,3.345,0,0,1,3.345,3.345v.178a3.344,3.344,0,0,1-3.345,3.345H94.067a3.344,3.344,0,0,1-3.345-3.345v-.178A3.345,3.345,0,0,1,94.067,449.3Z",
    transform: "translate(-90.722 -397.79)",
    fill: "#d4e1f4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_305",
    "data-name": "Trazado 305",
    d: "M168.645,420.007V431.39l-8.533,3.622a12.338,12.338,0,0,1-3.176.876l6.558-2.781v-10.92Z",
    transform: "translate(-105.121 -391.421)",
    fill: "#efd2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_306",
    "data-name": "Trazado 306",
    d: "M159.115,422.187v10.92l-6.558,2.781a13.39,13.39,0,0,1-7.228-.876L136.8,431.39V420.007l11.159,4.738,2.181.927a.907.907,0,0,0,.79,0Z",
    transform: "translate(-100.741 -391.421)",
    fill: "#f1eaf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_307",
    "data-name": "Trazado 307",
    d: "M169.728,412.548l-5.167,2.2-2.679,1.133-13.34,5.666a.907.907,0,0,1-.79,0l-13.34-5.666-7.847-3.33a1.389,1.389,0,0,1-.257-2.266.952.952,0,0,1,.257-.172l21.186-9a.907.907,0,0,1,.79,0l21.186,9a1.38,1.38,0,0,1,0,2.438Z",
    transform: "translate(-98.358 -387.293)",
    fill: "#efd2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_308",
    "data-name": "Trazado 308",
    d: "M164.561,415.4l-2.679,1.133-13.34,5.666a.913.913,0,0,1-.79,0l-13.34-5.666-7.847-3.331a1.389,1.389,0,0,1-.257-2.266l16.019-6.8a.913.913,0,0,1,.79,0l21.186,9a1.39,1.39,0,0,1,.258,2.266Z",
    transform: "translate(-98.358 -387.951)",
    fill: "#f1eaf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_309",
    "data-name": "Trazado 309",
    d: "M92.439,501.952h96.144a1.716,1.716,0,0,1,1.717,1.716V507.1a1.717,1.717,0,0,1-1.717,1.717H92.439a1.717,1.717,0,0,1-1.717-1.717v-3.434A1.716,1.716,0,0,1,92.439,501.952Z",
    transform: "translate(-90.722 -409.241)",
    fill: "#a4c2f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_310",
    "data-name": "Trazado 310",
    d: "M92.394,501.952h91.083a1.672,1.672,0,0,1,1.672,1.672v3.523a1.672,1.672,0,0,1-1.672,1.672H92.394a1.673,1.673,0,0,1-1.672-1.672v-3.523A1.672,1.672,0,0,1,92.394,501.952Z",
    transform: "translate(-90.722 -409.241)",
    fill: "#d4e1f4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_29",
    "data-name": "Grupo 29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_311",
    "data-name": "Trazado 311",
    d: "M141.183,494.21v3.924h5.151V494.21a9.906,9.906,0,0,1,7.726-9.489,10.776,10.776,0,0,0-2.575-.322A10.065,10.065,0,0,0,141.183,494.21Z",
    transform: "translate(-101.695 -405.423)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_312",
    "data-name": "Trazado 312",
    d: "M92.394,508.82h5.151a1.673,1.673,0,0,1-1.672-1.672v-3.524a1.671,1.671,0,0,1,1.672-1.672H92.394a1.671,1.671,0,0,0-1.672,1.672v3.524a1.673,1.673,0,0,0,1.672,1.672Z",
    transform: "translate(-90.722 -409.241)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_313",
    "data-name": "Trazado 313",
    d: "M150.717,473.715a6.851,6.851,0,0,1,4.292-6.36,6.867,6.867,0,1,0,0,12.719A6.851,6.851,0,0,1,150.717,473.715Z",
    transform: "translate(-102.645 -401.607)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_314",
    "data-name": "Trazado 314",
    d: "M192.4,473.715a6.849,6.849,0,0,1,4.291-6.36,6.867,6.867,0,1,0,0,12.719A6.849,6.849,0,0,1,192.4,473.715Z",
    transform: "translate(-111.71 -401.607)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_315",
    "data-name": "Trazado 315",
    d: "M109.032,473.715a6.849,6.849,0,0,1,4.291-6.36,6.867,6.867,0,1,0,0,12.719A6.851,6.851,0,0,1,109.032,473.715Z",
    transform: "translate(-93.58 -401.607)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_316",
    "data-name": "Trazado 316",
    d: "M99.5,498.134h5.151V494.21a9.9,9.9,0,0,1,7.726-9.489,10.747,10.747,0,0,0-2.575-.322,10.064,10.064,0,0,0-10.3,9.811Z",
    transform: "translate(-92.63 -405.423)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_317",
    "data-name": "Trazado 317",
    d: "M182.869,494.21v3.924h5.151V494.21a9.9,9.9,0,0,1,7.725-9.489,10.775,10.775,0,0,0-2.575-.322A10.064,10.064,0,0,0,182.869,494.21Z",
    transform: "translate(-110.76 -405.423)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_318",
    "data-name": "Trazado 318",
    d: "M94.066,441.851h5.151a3.344,3.344,0,0,1-3.344-3.344v-.18a3.345,3.345,0,0,1,3.344-3.344h3.524V390.345H99.216A3.344,3.344,0,0,1,95.873,387v-.18a3.345,3.345,0,0,1,3.344-3.344H94.066a3.345,3.345,0,0,0-3.344,3.344V387a3.344,3.344,0,0,0,3.344,3.344H97.59v44.638H94.066a3.344,3.344,0,0,0-3.344,3.345v.179A3.344,3.344,0,0,0,94.066,441.851Z",
    transform: "translate(-90.722 -383.477)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_32",
    "data-name": "Grupo 32",
    transform: "translate(88.528 381.283)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_319",
    "data-name": "Trazado 319",
    d: "M100.738,392.253v44.638H97.3V392.253Z",
    transform: "translate(-90.436 -383.669)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_31",
    "data-name": "Grupo 31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_320",
    "data-name": "Trazado 320",
    d: "M186.389,391.584a5.151,5.151,0,1,0,0-10.3H93.679a5.151,5.151,0,1,0,0,10.3H95.4v5.151a1.717,1.717,0,0,0,3.434,0v-5.151h82.409v41.2H98.829V410.47a1.717,1.717,0,1,0-3.434,0v22.319H93.679a5.151,5.151,0,1,0,0,10.3h92.711a5.151,5.151,0,1,0,0-10.3h-1.717v-41.2Zm1.717,46.355a1.719,1.719,0,0,1-1.717,1.717H93.679a1.717,1.717,0,1,1,0-3.434h92.711A1.719,1.719,0,0,1,188.106,437.94ZM97.112,388.151H93.679a1.717,1.717,0,1,1,0-3.434h92.711a1.717,1.717,0,1,1,0,3.434Z",
    transform: "translate(-88.528 -381.283)",
    fill: "#264ecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_321",
    "data-name": "Trazado 321",
    d: "M99.015,411.045a1.724,1.724,0,0,0,1.219-2.936l-.257-.206a1.293,1.293,0,0,0-.31-.156,1.07,1.07,0,0,0-.309-.1,2.517,2.517,0,0,0-.343-.034,1.8,1.8,0,0,0-1.219.5,1.693,1.693,0,0,0,.566,2.8A1.722,1.722,0,0,0,99.015,411.045Z",
    transform: "translate(-90.431 -387.008)",
    fill: "#264ecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_322",
    "data-name": "Trazado 322",
    d: "M169.919,413.651a3.085,3.085,0,0,0,0-5.6l-21.186-9a2.706,2.706,0,0,0-2.132,0l-21.185,9a3.005,3.005,0,0,0-1.785,2.8v11.9a1.717,1.717,0,0,0,3.434,0v-8.405l5.151,2.189v10.245l0,.019a1.718,1.718,0,0,0,.128.635c.118.185.239.368.364.549a1.713,1.713,0,0,0,.556.38l8.538,3.625a15.109,15.109,0,0,0,11.735,0l8.528-3.622a1.712,1.712,0,0,0,.556-.38q.187-.271.364-.549a1.721,1.721,0,0,0,.128-.635l0-.019V416.54Zm-22.252-11.32,20.054,8.523-6.979,2.966-.015.006-13.06,5.55-13.06-5.55-.015-.006-6.979-2.966Zm12.018,23.319-7.478,3.175a11.7,11.7,0,0,1-9.071,0l-7.487-3.179V418l10.952,4.654a2.706,2.706,0,0,0,2.132,0L159.686,418v7.65Z",
    transform: "translate(-96.161 -385.1)",
    fill: "#7821a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_323",
    "data-name": "Trazado 323",
    d: "M188.106,492.109h-3.434V489.9a11.484,11.484,0,0,0-6.444-10.2,8.585,8.585,0,1,0-11.147,0,11.485,11.485,0,0,0-6.445,10.2v2.208h-8.584V489.9a11.482,11.482,0,0,0-6.444-10.2,8.585,8.585,0,1,0-11.147,0,11.485,11.485,0,0,0-6.445,10.2v2.208h-8.584V489.9a11.482,11.482,0,0,0-6.444-10.2,8.585,8.585,0,1,0-11.147,0A11.482,11.482,0,0,0,95.4,489.9v2.208H91.962a3.437,3.437,0,0,0-3.434,3.434v3.434a3.438,3.438,0,0,0,3.434,3.434h96.144a3.437,3.437,0,0,0,3.434-3.434v-3.434A3.436,3.436,0,0,0,188.106,492.109Zm-20.6-18.886a5.15,5.15,0,1,1,5.15,5.151A5.15,5.15,0,0,1,167.5,473.223ZM164.07,489.9a8.6,8.6,0,0,1,17.169,0v2.208H164.07V489.9Zm-29.187-16.678a5.151,5.151,0,1,1,5.151,5.151A5.151,5.151,0,0,1,134.883,473.223ZM131.45,489.9a8.6,8.6,0,0,1,17.169,0v2.208H131.45V489.9Zm-29.186-16.678a5.151,5.151,0,1,1,5.151,5.151A5.151,5.151,0,0,1,102.263,473.223ZM98.829,489.9a8.6,8.6,0,0,1,17.169,0v2.208H98.829Zm-6.868,9.074v-3.434h96.144l0,3.434Z",
    transform: "translate(-88.528 -399.398)",
    fill: "#264ecc"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoDesarrollate);
export default __webpack_public_path__ + "static/media/icono-desarrollate.ad34cac47d17c2422d18e976798ddca8.svg";
export { ForwardRef as ReactComponent };